(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initPdpCollapse = () => {
		// 初始化：处理初始展开状态
		$(".spx-pdp-collapse--open").each(function () {
			const $collapse = $(this);
			$collapse.addClass("active");
			const $content = $collapse.find(".spx-pdp-collapse__content");
			$content.css("display", "block");
		});

		$(".spx-pdp-collapse__header")
			.off("click")
			.on("click", function () {
				const $header = $(this);
				const $collapse = $header.closest(".spx-pdp-collapse");
				const $content = $collapse.find(".spx-pdp-collapse__content");
				const isActive = $collapse.hasClass("active");

				if (!isActive) {
					$collapse.addClass("active");
					$header.attr("aria-expanded", "true");
					$content.stop().slideDown(300);
				} else {
					$collapse.removeClass("active");
					$header.attr("aria-expanded", "false");
					$content.stop().slideUp(300);
				}
			});

		// 支持键盘操作
		$(".spx-pdp-collapse__header").on("keydown", function (e) {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault();
				$(this).trigger("click");
			}
		});
	};

	const initPdpFeaturesDesc = () => {
		const maxHeight = 160; // 默认最大高度（和 CSS 一致）

		const updateToggleVisibility = ($container) => {
			const $content = $container.find(".pdp-features-desc__content");
			const $toggle = $container.find(".pdp-features-desc__toggle");

			if ($content.length === 0 || $toggle.length === 0) return;

			// 临时移除高度限制以获取真实高度
			const originalMaxHeight = $content.css("max-height");
			$content.css("max-height", "none");
			const contentHeight = $content[0].scrollHeight;
			$content.css("max-height", originalMaxHeight);

			// 保持与 CSS 的默认布局一致（CSS 中是 flex）
			if (contentHeight > maxHeight) {
				$toggle.css("display", "flex");
			} else {
				$toggle.hide();
				$toggle.attr("aria-expanded", "false");
			}
		};

		// 使用事件代理：避免 section/DOM 重新渲染后点击事件丢失
		$(document)
			.off("click.pdpFeaturesDesc", ".pdp-features-desc__toggle")
			.on("click.pdpFeaturesDesc", ".pdp-features-desc__toggle", function () {
				const $toggle = $(this);
				const $container = $toggle.closest(".pdp-features-desc");
				const $content = $container.find(".pdp-features-desc__content");
				const $toggleText = $toggle.find(".pdp-features-desc__toggle-text");

				if ($container.length === 0 || $content.length === 0 || $toggleText.length === 0) return;

				const isExpanded = $container.hasClass("expanded");

				if (!isExpanded) {
					$container.addClass("expanded");
					$toggle.attr("aria-expanded", "true");
					$toggleText.text($toggleText.data("less-text") || "Read Less");

					// 兼容性更稳：用像素值控制 max-height，而不是依赖 max-height: none
					const expandedHeight = $content[0].scrollHeight;
					$content.css("max-height", `${expandedHeight}px`);

					// 动画结束后放开约束，避免内容高度在后续变化时被裁切
					const prevTimeout = $container.data("pdpFeaturesDescTimeout");
					if (prevTimeout) window.clearTimeout(prevTimeout);
					const timeoutId = window.setTimeout(() => {
						if ($container.hasClass("expanded")) {
							$content.css("max-height", "none");
						}
					}, 320);
					$container.data("pdpFeaturesDescTimeout", timeoutId);
				} else {
					$container.removeClass("expanded");
					$toggle.attr("aria-expanded", "false");
					$toggleText.text($toggleText.data("more-text") || "Learn More");

					// 滚动到顶部
					$container[0].scrollIntoView({ behavior: "smooth", block: "start" });

					const prevTimeout = $container.data("pdpFeaturesDescTimeout");
					if (prevTimeout) window.clearTimeout(prevTimeout);
					$container.removeData("pdpFeaturesDescTimeout");

					// 收起回默认高度（和 CSS 默认一致）
					$content.css("max-height", `${maxHeight}px`);
				}
			});

		$(".pdp-features-desc").each(function () {
			const $container = $(this);
			const $content = $container.find(".pdp-features-desc__content");
			const $toggle = $container.find(".pdp-features-desc__toggle");
			const $toggleText = $toggle.find(".pdp-features-desc__toggle-text");

			if ($content.length === 0 || $toggle.length === 0 || $toggleText.length === 0) return;

			// 存储翻译文本
			const readMoreText = $toggleText.text();
			$toggleText.data("more-text", readMoreText);

			// 从按钮的 data-read-less 属性获取 "Read Less" 翻译
			// 注：优先用 attr，避免 jQuery data 对带短横线 key 的兼容问题
			const readLessText = $toggle.attr("data-read-less") || $toggle.data("read-less") || "Read Less";
			$toggleText.data("less-text", readLessText);

			// 初始化：未展开时强制回到默认高度，避免切换布局时出现错位
			if (!$container.hasClass("expanded")) {
				$content.css("max-height", `${maxHeight}px`);
			}

			updateToggleVisibility($container);
		});

		// 监听窗口大小变化：未展开时重新判断是否显示 toggle；已展开时更新高度
		$(window)
			.off("resize.pdpFeaturesDesc")
			.on("resize.pdpFeaturesDesc", function () {
				$(".pdp-features-desc").each(function () {
					const $container = $(this);
					const $content = $container.find(".pdp-features-desc__content");

					if ($container.hasClass("expanded")) {
						if ($content.length) {
							$content.css("max-height", `${$content[0].scrollHeight}px`);
						}
					} else {
						updateToggleVisibility($container);
					}
				});
			});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initPdpCollapse();
		initPdpFeaturesDesc();
	});

	initProductAccordion();
	initPdpCollapse();
	initPdpFeaturesDesc();
})();
